import { Antenna, Briefcase, Building2, Bug, Database, KeyRound, Map as MapIcon, Phone, ScrollText, ShieldCheck, Users, Workflow, type LucideIcon } from 'lucide-react'
import { type PermissionExpr } from '@/lib/permissions/check'
import { AUDIT_ACCESS } from '@/lib/permissions/audit'
import { EMPRESA_ACCESS } from '@/lib/permissions/empresa'

export interface AdminModule {
  href: string
  title: string
  description: string
  require: PermissionExpr
  icon: LucideIcon
}

export const ADMIN_MODULES: AdminModule[] = [
  {
    href: '/admin/users',
    title: 'Usuários',
    description: 'Gerencie usuários do sistema, papéis e acesso a canais.',
    require: 'users:read',
    icon: Users,
  },
  {
    href: '/admin/subroles',
    title: 'Subroles',
    description: 'Configure subroles e permissões granulares por canal.',
    require: 'subroles:read',
    icon: ShieldCheck,
  },
  {
    href: '/admin/channels',
    title: 'Canais',
    description: 'Gerencie templates e configurações dos canais.',
    require: 'channels:templates:manage',
    icon: Antenna,
  },
  {
    href: '/admin/phone-numbers',
    title: 'Telefones',
    description: 'Números WhatsApp do tenant: perfil comercial, capacidades e diagnóstico da Meta.',
    // O GET /whatsapp/phones exige channels:phones:read; gatear por channels:read mostrava o card e devolvia 403.
    require: 'channels:phones:read',
    icon: Phone,
  },
  {
    href: '/admin/whatsapp-account',
    title: 'Conta WhatsApp',
    description: 'A conta WhatsApp Business (WABA) do tenant: verificação, limites e saúde.',
    require: 'channels:account:read',
    icon: Building2,
  },
  {
    href: '/admin/audit',
    title: 'Auditoria',
    description: 'Equipe, presença, atividade, erros, acessos e rede da equipe.',
    require: AUDIT_ACCESS,
    icon: ScrollText,
  },
  {
    href: '/admin/api-keys',
    title: 'API Keys',
    description: 'Credenciais máquina-a-máquina pra RPAs e integrações autenticarem na API.',
    require: 'api_keys:manage',
    icon: KeyRound,
  },
  {
    href: '/admin/decision-trees',
    title: 'Árvores de decisão',
    description: 'Monte os fluxos de bot que respondem as conversas de entrada.',
    require: 'flows:read',
    icon: Workflow,
  },
  {
    href: '/admin/flow-maps',
    title: 'Mapas de roteamento',
    description: 'Tabelas de lookup do nó map.resolve — editar entradas não versiona os flows.',
    require: 'flow_maps:read',
    icon: MapIcon,
  },
  {
    href: '/admin/cache',
    title: 'Cache',
    description: 'Namespaces do cache Redis do tenant com flush granular (ops).',
    require: 'admin:cache:manage',
    icon: Database,
  },
  {
    href: '/admin/empresa',
    title: 'Empresa',
    description: 'Perfil do tenant, envio em lote, integração com a Meta, OmniCare e políticas de acesso.',
    // OR das permissions das abas: só Segurança some sem a dela; as outras mostram "sem permissão" no painel.
    require: EMPRESA_ACCESS,
    icon: Briefcase,
  },
  {
    href: '/admin/errors',
    title: 'Erros HTTP',
    description: 'Erros 4xx e 5xx capturados nas requisições da API, com traceback e contexto.',
    // As 3 rotas de /admin/errors exigem admin:logs:read; grant runtime-only, fora de todo preset.
    require: 'admin:logs:read',
    icon: Bug,
  },
]
